import LayoutPage from "../../Components/LayoutPage";
import CardContainer from "./Components/CardContainer";
import TopMessage from "./Components/TopMessage";
import KYCList from "./Components/KYCList";
import TransactionsList from "./Components/TransactionList";
export default function Dashboard() {
  return (
    <LayoutPage
      activeIndex={1}
      navItems={["میز کار"]}
      childrenClassName="w-full flex flex-col gap-5 overflow-y-auto"
    >
      <TopMessage />
      <CardContainer />
      <KYCList />
      <TransactionsList />
    </LayoutPage>
  );
}
